import React, { ChangeEvent, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import CompanyName from '../../commonComponents/CompanyName';
import useAppContext from '../../../hooks/useAppContext';
import { AppContextType } from '../../../context/AppContext';
import { CompanyNameType } from '../../../static/types/commonTypes/companyNameType';
import Decision from '../../commonComponents/Decision';
import { DecisionType } from '../../../static/types/commonTypes/decisionType';
import LegalEntity from '../../commonComponents/LegalEntity';
import { LegalEntityType } from '../../../static/types/commonTypes/legalEntityType';
import HeadOfficeAddress from '../../commonComponents/HeadOfficeAddress';
import { HeadOfficeAddressType } from '../../../static/types/commonTypes/headOfficeAddressType';
import { DateType } from '../../../static/types/commonTypes/dateType';
import { initialManagerListStatewithQualities } from '../../../static/types/objectInitialState';
import { ManagerTypeWithQualite } from '../../../static/types/commonTypes/managerType';
import { getCityWithPreposition } from '../../../utils/functions/getCityWithPreposition';
import ManagerListWithQualities from '../../commonComponents/ManagerListWithQualities';
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { FaUpload } from 'react-icons/fa';
import { GoArrowRight } from 'react-icons/go';
import DateComponent from '../../commonComponents/DateComponent';
import DecisionWithQuality from '../../commonComponents/DecisionWithQuality';
import { formatObjectText } from '../../../utils/functions/formatObjectText';

interface AnnonceProps {
    txtAnnonce: string;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    activeIndex: number;
    updateActiveIndex: (index: number) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;
}

const TransfertSiegeDepartement: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateTxtAnnonce,
    updateActiveIndex,
    updateDenomination,
    societyType,

}) => {
    const {
        companyName, setCompanyName,
        companyNameValidity, setCompanyNameValidity,
        companyNameChecked, setCompanyNameChecked,


        generalManagersWithQualite,
        setGeneralManagersWithQualite,
        generalManagersWithQualiteValidity,
        setGeneralManagersWithQualiteValidity,
        generalManagersWithQualiteChecked,
        setGeneralManagersWithQualiteChecked,
        typeGeneralManagersWithQualiteData,
        setTypeGeneralManagersWithQualiteData,

        decisionWithQuality,
        setDecisionWithQuality,
        decisionWithQualityValidity,
        setDecisionWithQualityValidity,
        decisionWithQualityChecked,
        setDecisionWithQualityChecked,

        date, setDate,
        dateValidity, setDateValidity,
        dateChecked, setDateChecked,

        headOfficeAddress, setHeadOfficeAddress,
        headOfficeAddressValidity, setHeadOfficeAddressValidity,
        headOfficeAddressChecked, setHeadOfficeAddressChecked,

        legalEntity, setLegalEntity,
        legalEntityValidity, setLegalEntityValidity,
        legalEntityChecked, setLegalEntityChecked,

    } = useAppContext() as AppContextType

    const [visitedTabs, setVisitedTabs] = useState(['raisonSociale']);
    const [activeTab, setActiveTab] = useState<string>('raisonSociale');
    const [submissive, setSubmissive] = useState<boolean>(false)
    const societyTypeOptions = Array.isArray(societyType) ? societyType : [societyType]
    const firstPartDecision = [
        "AG Extraordinaire",
        "AG Ordinaire",
        "AG Mixte"
    ]

    const updateCompanyName = (data: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...data });
    const updateLegalEntity = (data: Partial<LegalEntityType>) => setLegalEntity({ ...legalEntity, ...data });
    const updateHeadOfficeAddress = (data: Partial<HeadOfficeAddressType>) => setHeadOfficeAddress({ ...headOfficeAddress, ...data });
    const updateHeadOfficeAddressValidity = (isValid: boolean) => setHeadOfficeAddressValidity(isValid);
    const goToSupportPresse = () => updateActiveIndex(2)

    const switchTab = (tab: string) => {
        setActiveTab(tab);
    };

    const handleSubmit = (e: ChangeEvent<HTMLFormElement>) => {

        e.preventDefault();

        console.log(validate())

        if (validate()) {

            const processedManagersData = generalManagersWithQualite.reduce((accumulator: {[key:string]: Array<ManagerTypeWithQualite> }, currentManager: ManagerTypeWithQualite ) => {
                if( accumulator[currentManager.qualite ]) {
                    accumulator[currentManager.qualite ] = [ ...accumulator[currentManager.qualite ], currentManager ]
                }
                else{
                    accumulator[currentManager.qualite] = [ currentManager ]
                }
                return accumulator
            }, {})
            
            const pluralSubjects = ["Les associés","Les actionnaires"];

            const verb = pluralSubjects.includes(decisionWithQuality.decisionQuality) ? "ont" : "a";
            const decisionNature = decisionWithQuality.decisionNature === "AG Extraordinaire"
                ? "l'AGE"
                : decisionWithQuality.decisionNature === "AG Ordinaire"
                    ? "l'AGO"
                    : decisionWithQuality.decisionNature === "AG Mixte"
                        ? "l'AG Mixte"
                        : decisionWithQuality.decisionNature

            const decisionText = firstPartDecision.includes(decisionWithQuality.decisionNature)
                ? `Aux termes de ${decisionNature} en date du ${decisionWithQuality.decisionDate} ${decisionWithQuality.decisionQuality} ${verb}`
                : `Le ${decisionWithQuality.decisionDate}, ${decisionNature.toLowerCase()} ${verb}`

            const tempText = `${legalEntity.companyName},
${legalEntity.legalForm} au capital de ${legalEntity.capital} €.
Siège social :
${legalEntity.address} ${legalEntity.additionalAddress ?? ""} ${legalEntity.postalCode} ${legalEntity.city}
${legalEntity.rcs} RCS ${getCityWithPreposition(legalEntity.registrationOffice)}.
${decisionText} décidé de transférer le siège social ${headOfficeAddress.address} ${headOfficeAddress.additionalAddress} ${headOfficeAddress.postalCode}  ${headOfficeAddress.city}, à compter du ${date.date}.
Radiation au RCS  ${getCityWithPreposition(legalEntity.registrationOffice)} et réimmatriculation au RCS ${getCityWithPreposition(headOfficeAddress.registrationOffice)}.`

            const formattedText = formatObjectText(tempText);
            updateTxtAnnonce(formattedText);
            updateDenomination(companyName.companyName);
            setSubmissive(true)
            console.log("nvalid")
        }

        else setSubmissive(false)
    };

    const validate = () => {
        if (!companyNameValidity) {
            setActiveTab('raisonSociale')
        }
        else if (!decisionWithQualityValidity) {
            setActiveTab('choisirDateDecision')
        }
        else if (!legalEntityValidity) {
            setActiveTab('laSociété')
        }
        else if (!headOfficeAddressValidity) {
            setActiveTab('nouvelleAdresseSiegeSocial')
        }
        else if (!dateValidity) {
            setActiveTab('dateEffet')
        }
        else if (typeGeneralManagersWithQualiteData === 1 && !generalManagersWithQualiteValidity) {
            setActiveTab('geranceOupResidence')
        }

        let tempGeneralManagersValidity = typeGeneralManagersWithQualiteData === 1 ? generalManagersWithQualiteValidity : true

        return companyNameValidity && decisionWithQualityValidity && legalEntityValidity && headOfficeAddressValidity && dateValidity && tempGeneralManagersValidity
    };
    const handleNext = () => {
        if (activeTab === "raisonSociale") {
            setCompanyNameChecked(true)
            if (companyNameValidity) {
                switchTab(getNextTab("raisonSociale"));
            }
        } else if (activeTab === "choisirDateDecision") {
            setDecisionWithQualityChecked(true)
            if (decisionWithQualityValidity) {
                switchTab(getNextTab("choisirDateDecision"));
            }
        } else if (activeTab === "laSociété") {
            setLegalEntityChecked(true)
            if (legalEntityValidity) {
                switchTab(getNextTab("laSociété"));
            }
        } else if (activeTab === "nouvelleAdresseSiegeSocial") {
            setHeadOfficeAddressChecked(true)
            if (headOfficeAddressValidity) {
                switchTab(getNextTab("nouvelleAdresseSiegeSocial"));
            }
        } else if (activeTab === "dateEffet") {
            setDateChecked(true)
            if (dateValidity) {
                switchTab(getNextTab("dateEffet"));
            }
        } else if (activeTab === 'geranceOupResidence') {
            setGeneralManagersWithQualiteChecked(true);
            if (typeGeneralManagersWithQualiteData === 1) {
                if (generalManagersWithQualiteValidity) {
                    setSubmissive(true)
                }
            }
            else {
                setSubmissive(true)
            }
        }
    };


    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
        setSubmissive(false);
    };

    const getNextTab = (currentTab: string) => {
        switch (currentTab) {
            case 'raisonSociale':
                return 'choisirDateDecision';
            case 'choisirDateDecision':
                return 'laSociété';
            case 'laSociété':
                return 'nouvelleAdresseSiegeSocial';
            case 'nouvelleAdresseSiegeSocial':
                return 'dateEffet';
            case 'dateEffet':
                return 'geranceOupResidence';
            default:
                return currentTab;
        }
    };

    const getPreviousTab = (currentTab: string) => {
        switch (currentTab) {
            case 'geranceOupResidence':
                return 'dateEffet';
            case 'dateEffet':
                return 'nouvelleAdresseSiegeSocial';
            case 'nouvelleAdresseSiegeSocial':
                return 'laSociété';
            case 'laSociété':
                return 'choisirDateDecision';
            case 'choisirDateDecision':
                return 'raisonSociale';
            default:
                return currentTab;
        }
    };

    const updateDate = (partialData: Partial<DateType>) => setDate({ ...date, ...partialData })
    const updateDecision = (data: Partial<DecisionType>) => setDecisionWithQuality({ ...decisionWithQuality, ...data });

    const tabs  =  [
        {key: 'raisonSociale', label: 'Raison Sociale'},
        {key: 'choisirDateDecision', label: "Choisir l'organe et la date de la décision"},
        {key: 'laSociété', label: 'La société'},
        {key: 'nouvelleAdresseSiegeSocial', label: 'Nouvelle adresse du siège social'},
        {key: 'dateEffet', label: "Date d'Effet"},
        {key: 'geranceOupResidence', label: 'La Gérance / Présidence (Représentant légal)'},
    ]
    return (
        <>
                <div className="container my-3">
                <ul className="nav nav-underline">
                    {tabs
                    .filter((t) => t.key === activeTab) 
                    .map((t) => (
                        <li className="nav-item" key={t.key}>
                        <a
                            href={`#${t.key}`}
                            className={`nav-link active`} 
                        >
                            {t.label}
                        </a>
                        </li>
                    ))}
                    </ul>
                </div>

            <ToastContainer />
            <form onSubmit={handleSubmit}>

                {
                    activeTab === 'raisonSociale' &&
                    <div>
                        <span>
                            Indiquer la raison sociale de la société ou la dénomination du Cabinet de Notaire annonceur ou l'état civil de la personne concernée par l'annonce, en optionnel vous pouvez ajouter une référence client.
                        </span>
                        <div className="tab-content">
                            <CompanyName
                                changeCompanyName={updateCompanyName}
                                companyName={companyName}
                                checked={companyNameChecked}
                                onValidationChange={(isValid: boolean) => setCompanyNameValidity(isValid)}
                                showClientReference={true}
                            />
                        </div>

                    </div>

                }
                {
                    activeTab === 'choisirDateDecision' &&
                    <DecisionWithQuality
                        decisionWithQuality={decisionWithQuality}
                        draftFieldName = 'decisionWithQuality'
                        checked={decisionWithQualityChecked}
                        dateLabel='Date'
                        changeDecision={updateDecision}
                        onValidationChange={(isValid: boolean) => setDecisionWithQualityValidity(isValid)}
                        decisionQualityOptions={[
                            "L'associé unique",
                            "Les associés",
                            "Les actionnaires"
                        ]}
                        decisionNatureOptions={[
                            "AG Extraordinaire",
                            "AG Ordinaire",
                            "AG Mixte",
                            "Le gérant",
                            "Le président",
                            "Le conseil d'administration",
                            "Décision unanime des associés"
                        ]}
                    />
                }
                {
                    activeTab === 'laSociété' &&
                    <div>
                        <span>
                            Pour la société, veuillez préciser l'adresse du siège social
                        </span>
                        <div className="tab-content">
                            <LegalEntity
                                companyName={companyName}
                                setCompanyName={(updatedData: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...updatedData })}
                                checked={legalEntityChecked}
                                legalEntity={legalEntity}
                                changeLegalEntity={updateLegalEntity}
                                societyType={societyTypeOptions}
                                onValidationChange={(isValid: boolean) => setLegalEntityValidity(isValid)}
                                draftFieldName = 'legalEntity'
                            />
                        </div>

                    </div>

                }
                {
                    activeTab === "nouvelleAdresseSiegeSocial" &&
                    <HeadOfficeAddress
                        changeHeadOfficeAddress={updateHeadOfficeAddress}
                        checked={headOfficeAddressChecked}
                        headOfficeAddress={headOfficeAddress}
                        onValidationChange={updateHeadOfficeAddressValidity}
                    />
                }
                {
                    activeTab === 'dateEffet' &&
                        <div className="col-md-6">
                            <DateComponent
                                id='dateEffet'
                                date= {date}
                                changeDate= {updateDate}
                                checked= {dateChecked}
                                required= {true}
                                dateLabel= "Date d'effet"
                                onValidationChange={(isValid: boolean) => setDateValidity (isValid)}
                            />
                        </div>
                    
                }

                {
                    activeTab === "geranceOupResidence" &&
                    <>
                        <div className="mb-3 row">
                            <strong>
                                Si vous changez de ressort de greffe de Tribunal de Commerce, vous devez saisir le nom et l'adresse personnelle du (ou des) dirigeant(s), excepté pour les sociétés civiles.
                            </strong>
                            <label htmlFor="personne" className="col-sm-2 col-form-label mt-3">
                                Saisir un dirigeant
                            </label>
                            <div className="col-sm-10 mt-3">
                                <select
                                    className="form-select"
                                    id="person"
                                    onChange={(e) => {
                                        setGeneralManagersWithQualite(initialManagerListStatewithQualities)
                                        setTypeGeneralManagersWithQualiteData(Number(e.target.value))
                                    }}
                                    value={typeGeneralManagersWithQualiteData}
                                >
                                    <option value={1}> Oui </option>
                                    <option value={0}> Non </option>
                                </select>
                            </div>
                        </div>
                        {
                            typeGeneralManagersWithQualiteData === 1 &&

                            <ManagerListWithQualities
                                addButtonText='Ajouter un dirigeant'
                                removeButtonText='Supprimer le dernier dirigeant'
                                checked={generalManagersWithQualiteChecked}
                                managers={generalManagersWithQualite}
                                qualitiesOptions={[
                                    "Gérant",
                                    "Co-gérant",
                                    "Président",
                                    "Directeur Général",
                                    "Directeur Général Délégué",
                                    "Président du conseil d'administration ",
                                    "Président du conseil d'admin. et Directeur Général"
                                ]}
                                setManagers={setGeneralManagersWithQualite}
                                setManagersValidity={setGeneralManagersWithQualiteValidity}
                                societyTypeOptions={societyTypeOptions}
                            />

                        }
                    </>
                }
                {
                    activeTab === "geranceOupResidence" &&
                    submissive &&
                    <div className="mt-4">
                        <h4>Texte de l'annonce:</h4>
                        <textarea
                            className="form-control"
                            rows={5}
                            value={txtAnnonce}
                            disabled
                        />
                    </div>
                }

                <div className="button-container">
                    <div className="d-flex gap-2">
                        {
                            activeTab !== "raisonSociale" &&
                            <button
                                color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={handlePrevious}
                            >
                                <SlArrowLeft className="icon" style={{ marginRight: '10px', fontSize: '20px' }} />
                                Modifier mon annonce
                            </button>
                        }
                        {
                            activeTab === "geranceOupResidence" &&
                            <button type="submit"
                                onClick={handleNext}>
                                Mettre à jour mon annonce
                                <FaUpload className="icon" style={{ marginLeft: '15px', fontSize: '20px' }} />
                            </button>
                        }
                        {
                            activeTab !== "geranceOupResidence" &&
                            <button
                                color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={handleNext}>
                                Suivant
                                <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                            </button>
                        }

                        {
                            submissive &&
                            activeTab === "geranceOupResidence" &&
                            <button
                                color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={goToSupportPresse}
                            >
                                Sélection du support
                                <GoArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                            </button>
                        }
                    </div>
                </div>
            </form>

        </>
    );
};

export default TransfertSiegeDepartement;